import TextBasedSectionContainer from '@/components/TextBasedSectionContainer'
import kwesforms from 'kwesforms'
import { useEffect } from 'react'
import Link from 'next/link'

export default function Contact() {
  useEffect(() => {
    kwesforms.init()
  }, [])

  return (
    <>
      {/*<form
          className="kwes-form"
          action="https://kwesforms.com/api/foreign/forms/uKoFQxRU9NfoqpFhVzF0"
        >
          <label htmlFor="name">Your Name</label>
          <input type="text" name="name" />
          <button type="submit">Submit</button>
  </form>*/}
      <section>
        <div className="mx-auto max-w-screen-md py-8 px-4 lg:py-16">
          <h2 className="mb-4 text-center text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white">
            Contact Us
          </h2>
          <p className="mb-8 text-center font-light text-gray-500 dark:text-gray-400 sm:text-xl lg:mb-16">
            Want to send feedback about a feature? Got questions about Animerdle?
          </p>
          <form
            className="kwes-form"
            action="https://kwesforms.com/api/foreign/forms/uKoFQxRU9NfoqpFhVzF0"
          >
            <div className="space-y-8 rounded-lg px-8 py-10 dark:bg-gray-800">
              <div>
                <label
                  htmlFor="email"
                  className="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Your email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="dark:shadow-sm-light block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500"
                  placeholder="name@email.com"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="subject"
                  className="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="dark:shadow-sm-light block w-full rounded-lg border border-gray-300 bg-gray-50 p-3 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500"
                  placeholder="Let us know how we can help you"
                  required
                />
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="message"
                  className="mb-2 block text-sm font-medium text-gray-900 dark:text-gray-400"
                >
                  Your message
                </label>
                <textarea
                  id="message"
                  rows="6"
                  name="message"
                  className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-500 dark:focus:ring-primary-500"
                  placeholder="Leave a comment..."
                  required
                ></textarea>
              </div>
              <p className="prose-xs max-w-none dark:prose-dark">
                <small>
                  By submitting this form you agree to our our{' '}
                  <Link href="/privacypolicy" title="Privacy Policy">
                    Privacy Policy
                  </Link>{' '}
                  which explains how we may collect, use and disclose your personal information
                  including to third parties.
                </small>
              </p>
              <button
                type="submit"
                className="rounded-lg bg-primary-700 py-3 px-5 text-center text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 sm:w-fit"
              >
                Send message
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  )
}
